module.exports = __webpack_public_path__ + "img/intro-circles.38c725f0.svg";